import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchQuery,
    deleteQuery,
} from "../../Redux/Reducers/UserFeedbackReducerList";
import {
    Box,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button as MuiButton,
    Tooltip,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import PageHeader1 from "../../components/common/PageHeader1";
import { usePermissions } from "../../context/AuthContext";

function AstroSupportDetails() {
    const { can } = usePermissions();
    const dispatch = useDispatch();
    const { data: FeedbackData, status, error } = useSelector((state) => state.UserFeedbackReducerList || {});

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
    const [filterModel, setFilterModel] = useState({
        items: [],
        quickFilterExcludeHiddenColumns: true,
        quickFilterValues: [''],
    });

    const [selectedFeedbackId, setSelectedFeedbackId] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        dispatch(fetchQuery());
    }, [dispatch]);

    const handleClickOpen = (feedbackId) => {
        setSelectedFeedbackId(feedbackId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedFeedbackId(null);
    };

    const handleDelete = () => {
        if (selectedFeedbackId) {
            dispatch(deleteQuery(selectedFeedbackId));
            dispatch(fetchQuery());
            handleClose();
        }
    };

    const columns = [
        { field: "sono", headerName: "S.No.", width: 80 },
        { field: "name", headerName: "User Name", width: 200 },
        { field: "email", headerName: "Email", width: 100 },
        { field: "mobile", headerName: "Phone Number", width: 150 },
        {
            field: "feedback",
            headerName: "Query",
            width: 250,
            renderCell: ({ row }) => (
                <span>
                    {row?.feedback?.length > 25
                        ? row.feedback.substring(0, 25) + "..."
                        : row.feedback}
                </span>
            ),
        },
        { field: 'createdAt', headerName: 'Created At', width: 200 },
        {
            field: "actions",
            headerName: "Actions",
            width: 150,
            renderCell: ({ row }) => (
                <div>
                    <Tooltip title="View Details">
                        <IconButton
                            component={Link}
                            to={`/AstroView-detail/${row.id}`}
                        >
                            <i className="icofont-eye text-info"></i>
                        </IconButton>
                    </Tooltip>
                    <IconButton onClick={() => handleClickOpen(row.id)}>
                        <i className="icofont-ui-delete text-danger"></i>
                    </IconButton>
                </div>
            ),
        },
    ];

    const rows = Array.isArray(FeedbackData) ? FeedbackData?.map((feedback, index) => ({
        sono: index + 1,
        id: feedback?._id,
        name: feedback?.name,
        email: feedback?.email,
        mobile: feedback?.mobile,
        feedback: feedback?.query,
        createdAt: feedback?.createdAt
            ? new Date(feedback?.createdAt).toLocaleString()
            : "",
    })) : [];

    if (status === 'loading') return <p>Loading...</p>;
    if (status === 'failed') return <p>Error: {error}</p>;

    return (
        <div className="body d-flex py-1">
            <div className="container-xxl">
                <PageHeader1 pagetitle="Astro Feedback List" />

                <div className="row g-0 mb-3">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <Box sx={{ width: "100%" }}>
                                    <Box sx={{ height: 500 }}>
                                        <DataGrid
                                            columns={columns}
                                            rows={rows}
                                            getRowId={(row) => row.id}
                                            disableRowSelectionOnClick
                                            slots={{ toolbar: GridToolbar }}
                                            filterModel={filterModel}
                                            onFilterModelChange={(newModel) => setFilterModel(newModel)}
                                            slotProps={{ toolbar: { showQuickFilter: true } }}
                                            columnVisibilityModel={columnVisibilityModel}
                                            onColumnVisibilityModelChange={(newModel) =>
                                                setColumnVisibilityModel(newModel)
                                            }
                                            autoHeight
                                        />
                                    </Box>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Delete Confirmation</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete this feedback?
                </DialogContent>
                <DialogActions>
                    <MuiButton onClick={handleClose}>
                        Cancel
                    </MuiButton>
                    <MuiButton onClick={handleDelete} color="error">
                        Delete
                    </MuiButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default AstroSupportDetails;